import { gql } from '@apollo/client'

const DESCRIPTION_FIELDS = gql`
  fragment DescriptionFields on StudyToolsDescriptionType {
    id
    page
    description
  }
`

export const FIND_ALL_DESCRIPTIONS = gql`
  ${DESCRIPTION_FIELDS}
  query FindAllStudyToolsDescription($query: StudyToolsDescriptionQueryInput!) {
    findAllStudyToolsDescription(query: $query) {
      items {
        ...DescriptionFields
      }
    }
  }
`

export const CREATE_OR_UPDATE_DESCRIPTIONS = gql`
  ${DESCRIPTION_FIELDS}
  mutation CreateOrUpdateStudyToolsDescription($input: UpdateStudyToolsDescriptionInput!) {
    createOrUpdateStudyToolsDescription(createOrUpdateStudyToolsDescriptionInputFieldName: $input) {
      ...DescriptionFields
    }
  }
`
